module.exports = __webpack_public_path__ + "static/media/2.418dbcb3.jpg";